import { Helper } from '../Helper';
export class RawEnumeratorReduceHelper extends Helper {
    constructor(options) {
        super();
        this.each = options.each;
    }
    emit(sb, node, options) {
        sb.emitHelper(node, options, sb.helpers.rawIteratorReduceBase({
            each: (innerOptions) => {
                sb.emitOp(node, 'SWAP');
                sb.emitSysCall(node, 'Neo.Enumerator.Value');
                sb.emitOp(node, 'SWAP');
                this.each(innerOptions);
            },
        }));
    }
}

//# sourceMappingURL=RawEnumeratorReduceHelper.js.map
